import React from "react"

function IconHouse({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="house"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-house"
      {...props}
    >
      <path
        d="m12.273 3.466.083.051 9.5 7a.6.6 0 0 1-.629 1.017l-.083-.051-1.814-1.337-.004 8.93a1.601 1.601 0 0 1-1.455 1.592l-.146.007H6.2a1.6 1.6 0 0 1-1.593-1.454l-.007-.146v-8.878l-1.744 1.286a.6.6 0 0 1-.775-.053l-.064-.074a.6.6 0 0 1 .053-.775l.074-.064 9.5-7a.6.6 0 0 1 .63-.051zM12 4.745 5.8 9.313v9.762a.4.4 0 0 0 .32.392l.08.008 3.2-.001V15a1.6 1.6 0 0 1 1.454-1.593L11 13.4h2a1.6 1.6 0 0 1 1.593 1.454L14.6 15v4.475h3.125a.401.401 0 0 0 .393-.32l.008-.08.004-9.813L12 4.745zm1 9.855h-2a.4.4 0 0 0-.392.32L10.6 15v4.474l2.8.001V15a.4.4 0 0 0-.32-.392L13 14.6z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconHouse
